import React from 'react';

const Maintenance = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900 px-4">
      <div className="max-w-lg w-full text-center space-y-8">
        {/* Logo */}
        <img
          src="/images/imr-logo.png"
          alt="IMR Logo"
          className="h-32 w-auto mx-auto"
        />
        
        {/* Maintenance Icon */}
        <div className="flex justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
          </svg>
        </div>

        {/* Maintenance Message */}
        <div className="bg-gray-800/90 shadow-lg rounded-lg p-8 border border-gray-700 backdrop-blur-sm">
          <h1 className="text-3xl font-bold text-yellow-500 mb-4">
            Under Maintenance
          </h1>
          <p className="text-xl text-gray-300 mb-6">
            We're currently performing some maintenance on our servers.
          </p>
          <p className="text-gray-400">
            We'll be back online shortly. Thank you for your patience.
          </p>
          <div className="mt-8 flex justify-center items-center space-x-2">
            <div className="animate-pulse flex space-x-2">
              <div className="h-3 w-3 bg-yellow-500 rounded-full"></div>
              <div className="h-3 w-3 bg-yellow-500 rounded-full"></div>
              <div className="h-3 w-3 bg-yellow-500 rounded-full"></div>
            </div>
          </div>
        </div>

        {/* Contact Information */}
        <div className="text-gray-400 text-sm">
          <p>If you need immediate assistance, please contact us at:</p>
          <a 
            href="mailto:directory@defencepartners.in" 
            className="text-yellow-500 hover:text-yellow-400 transition-colors duration-200"
          >
            directory@defencepartners.in
          </a>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
